import { handleActions } from 'redux-actions';
import { State, stateUpdate, stateClear, stateReload } from './action';

const initialState: State = {
  isLoading: false,
  isReload: false,
};

export default handleActions(
  {
    [String(stateUpdate)]: (state, { payload }) => {
      return {
        ...state,
        ...payload,
      };
    },
    [String(stateReload)]: (state) => {
      return {
        ...state,
        isReload: !state.isReload,
      };
    },
    [String(stateClear)]: () => {
      return initialState;
    },
  },
  initialState,
);
